module.exports = __webpack_public_path__ + "static/media/video-revision-en.31eb6a4b.vtt";